const BASE_URL = process.env.REACT_APP_BASE_URL;

// Feature flags arrive from the environment as strings, so a feature is on only when
// it is explicitly turned on. A missing or unrecognised value leaves it off.
const isEnabled = (value) => ['true', '1'].includes(String(value).trim().toLowerCase());

const Constants = {
    BASE_URL: BASE_URL,
    // Announcements: the section on the home screen, the sidebar link and the
    // /annoucement page. Off unless REACT_APP_SHOW_ANNOUNCEMENTS=true is set.
    SHOW_ANNOUNCEMENTS: isEnabled(process.env.REACT_APP_SHOW_ANNOUNCEMENTS),
}


export default Constants;